/**
 * Cache para o token de autenticação para reduzir chamadas ao storage
 */

let cachedToken: string | null = null;
let refreshTokenCached: string | null = null;

/**
 * Recupera o token de autenticação, usando o cache quando disponível
 */
export const getAuthToken = async (): Promise<string | null> => {
  // Retorna apenas o token cacheado em memória, se existir.
  // Remove a lógica de fallback para localStorage.
  return cachedToken;
};

/**
 * Recupera o refresh token, usando o cache quando disponível
 */
export const getRefreshToken = async (): Promise<string | null> => {
  if (!refreshTokenCached) {
    // Verificar se localStorage está disponível (ambiente navegador)
    if (typeof localStorage !== 'undefined') {
      try {
        const storageData = localStorage.getItem('sb-qassqhqlzrwsjtelppku-auth-token');
        if (storageData) {
          // O formato do storage é JSON, então precisamos fazer o parse
          try {
            const tokenData = JSON.parse(storageData);
            refreshTokenCached = tokenData?.refresh_token || null;
          } catch (e) {
            console.error('[AuthTokenCache] Erro ao parsear dados de token:', e);
            return null;
          }
        }
      } catch (error) {
        console.error('[AuthTokenCache] Erro ao carregar refresh token:', error);
        return null;
      }
    } else {
      return null;
    }
  }
  return refreshTokenCached;
};

/**
 * Invalida o cache do token quando necessário (logout, expiração, etc)
 */
export const invalidateAuthTokenCache = (): void => {
  console.log('[AuthTokenCache] Cache de token invalidado');
  cachedToken = null;
  refreshTokenCached = null;
};

/**
 * Atualiza o cache com um novo token
 */
export const updateAuthTokenCache = (token: string): void => {
  console.log('[AuthTokenCache] Cache de token atualizado');
  
  // Atualizar token principal
  cachedToken = token;
  
  // Atualizar também o refresh token, se o token contiver um
  try {
    const tokenData = JSON.parse(token);
    if (tokenData?.refresh_token) {
      refreshTokenCached = tokenData.refresh_token;
      console.log('[AuthTokenCache] Cache de refresh token atualizado');
    }
  } catch (e) {
    // Se não for um JSON válido, não temos refresh token para extrair
    console.warn('[AuthTokenCache] Não foi possível extrair refresh token do valor fornecido');
  }
}; 